import classes from './fieldByType.module.css';

const IntegerTypeField = ({ item, selectItem, disabled, units, setNewSelectItem, forTable }) => {
  if (forTable) {
    const getNumericValue = () => {
      if (item == null) return '';
      if (typeof item === 'number') return item;
      if (item.value != null) {
        const num = parseFloat(item.value);
        return isNaN(num) ? '' : num;
      }
    };
    return <div>{getNumericValue()}</div>;
  }
  return (
    <div className={classes.numberBlock}>
      <input
        type={'number'}
        onWheel={(e) => e.target.blur()}
        className={classes.input}
        value={selectItem?.value}
        onChange={(e) => setNewSelectItem({ value: e.target.value ?? ' ', setting: item?.setting })}
        disabled={disabled}
      />
      <div>{units?.find((val) => val.id == item?.setting.unit)?.name}</div>
    </div>
  );
};

export default IntegerTypeField;
